import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import PresaleTitle from './PresaleTitle';
import PresaleStatus from './PresaleStatus'
import PresaleInfo from './PresaleInfo'

const PresaleBasicInformation = (props) => {    

    const lang = useSelector(state => state.layout.lang)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <Fragment>
            <PresaleTitle presale={props.presale} lang={lang} />
            <PresaleStatus presale={props.presale} lang={lang} />
            <PresaleInfo presale={props.presale} lang={lang}/>
        </Fragment>
    );
}

PresaleBasicInformation.propTypes = {
    presale: PropTypes.object
}
PresaleBasicInformation.whyDidYouRender = false;

export default PresaleBasicInformation